<template>
    <div class="w-full h-full relative flex gap-[30px] mt-[35px] justify-between">
        <div class="flex flex-col pl-[25px] pb-[169px] justify-between">
            <div class="w-[40vw]">
                <div class="font-medium text-[24px] tracking-[0%] leading-[100%]">Техническая поддержка</div>
                <div class="font-normal text-[16px] tracking-[0%] leading-[140%] mt-[20px] text-[#031425]">
                    Если вы столкнулись с трудностями на нашей платформе, обратитесь в техническую поддержку.
                </div>
                <div class="font-normal text-[16px] tracking-[0%] leading-[140%] mt-[10px] text-[#031425]">
                    Наши специалисты обучены и квалифицированны для оказания поддержки по любым вопросам, связанным с
                    использованием нашего продукта. Мы гарантируем быстрое реагирование на запросы и высокое качество
                    обслуживания.
                </div>
                <ai-button
                    class="mt-[30px] custom-button"
                    text="  Написать в техническую поддержку"
                    @click="togglePopupVisible"
                />
            </div>
            <div class="flex flex-col gap-[17px]">
                <div class="flex gap-[14px]">
                    <component :is="locationSvg" />
                    <p class="font-normal text-[16px] tracking-[0%] leading-[140%]">
                        <span class="font-medium text-[16px] tracking-[0%] leading-[140%]">Адрес компании:</span>
                        190005, СПб, Московский 25/1, лит. А, <br />
                        пом. 11Н, офис 32А
                    </p>
                </div>
                <div class="flex gap-[14px]">
                    <component :is="phoneSvg" />
                    <p class="font-normal text-[16px] tracking-[0%] leading-[140%]">
                        <span class="font-medium text-[16px] tracking-[0%] leading-[140%]">Телефон компании:</span> +7
                        (812) 336-30-10
                    </p>
                </div>
            </div>
        </div>
        <div class="pr-[25px] pb-[169px]">
            <img :src="supportPic" alt="support" class="w-full h-full" />
        </div>
    </div>
    <component :is="popupView" @popupClosed="onPopupClosed" />
</template>

<script>
export default {
    name: 'support-view',
};
</script>

<script setup>
import { ref } from 'vue';
import AiButton from '@/components/ai-button/ai-button.vue';
import supportPic from '@/assets/supportPic.png';

const locationSvg = ref('ai-location-svg');
const popupView = ref('');
const phoneSvg = ref('ai-phone-svg');

const togglePopupVisible = () => {
    popupView.value = 'support-popup';
};

const onPopupClosed = () => {
    popupView.value = '';
};
</script>

<style>
.custom-button .dx-button-text {
    text-transform: none;
    font-size: 16px;
    letter-spacing: 0%;
    line-height: 100%;
}

.custom-button .dx-button-content {
    padding: 15px 45px;
}
</style>
